//#region ../src/ar/qr/qr-capture-cadence.ts
/**
* How often a QR consumer captures a camera frame for detection: the default
* and the bounds every app validates against. See qr-capture-cadence.ts.md.
*/
/**
* Bounds of the QR capture interval, in milliseconds. Below ~50 ms the
* detector cannot keep up and frames only queue; above 1 s tracking feels
* dead. `step` is the settings slider's grid.
*/
const QR_CAPTURE_INTERVAL_CONSTRAINTS = {
	min: 50,
	max: 1e3,
	step: 25
};
/** The default QR capture interval: ~8 captures per second. */
const DEFAULT_QR_CAPTURE_INTERVAL_MS = 125;
//#endregion
export { DEFAULT_QR_CAPTURE_INTERVAL_MS, QR_CAPTURE_INTERVAL_CONSTRAINTS };
